"use client";

import { c as _c } from "react/compiler-runtime";
import { useAIChatInputContext } from "../contexts";
import { HiOutlineArrowSmUp } from "react-icons/hi";
import Button from "@/components/ui/button";
import { cx } from "@/lib/tailwind-utils";
interface AIChatInputSendButtonProps {
  className?: string;
}
export function AIChatInputSendButton(t0) {
  const $ = _c(9);
  const {
    className
  } = t0;
  const {
    state,
    actions
  } = useAIChatInputContext();
  if (state.isStreaming) {
    return null;
  }
  let t1;
  if ($[0] !== actions) {
    t1 = () => actions.send();
    $[0] = actions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HiOutlineArrowSmUp className="size-3.5" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = state.isDisabled;
  let t4;
  if ($[3] !== className) {
    t4 = cx("flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background/50 p-0", className);
    $[3] = className;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== state.isDisabled || $[6] !== t1 || $[7] !== t4) {
    t5 = <Button type="button" variant="secondary" onClick={t1} icon={t2} disabled={t3} className={t4} />;
    $[5] = state.isDisabled;
    $[6] = t1;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}